// extracted by mini-css-extract-plugin
module.exports =  {"content":"_1c9529d521--content--WXZO_"};